import { c as create$3 } from './form.js';
import { d as dateOfIncorporationValidation, t as taxIdValidation, i as industryValidation, c as businessClassificationValidation, e as doingBusinessAsValidation, f as phoneValidation, g as emailValidation, h as websiteUrlValidation, j as businessNameValidation } from './schema-validations.js';

const businessCoreInfoSchema = (allowOptionalFields) => {
    const schema = create$3({
        legal_name: businessNameValidation.required('Enter legal name'),
        website_url: websiteUrlValidation.required('Enter business website url'),
        email: emailValidation.required('Enter business email'),
        phone: phoneValidation.required('Enter phone number'),
        doing_business_as: doingBusinessAsValidation.nullable(),
        classification: businessClassificationValidation.required('Select business classification'),
        industry: industryValidation.required('Enter a business industry'),
        tax_id: taxIdValidation.required('Enter tax id, SSN, or EIN'),
        date_of_incorporation: dateOfIncorporationValidation.required('Enter date of incorporation'),
    });
    const easySchema = create$3({
        legal_name: businessNameValidation.required('Enter legal name'),
        website_url: websiteUrlValidation.nullable(),
        email: emailValidation.nullable(),
        phone: phoneValidation.nullable(),
        doing_business_as: doingBusinessAsValidation.nullable(),
        classification: businessClassificationValidation.nullable(),
        industry: industryValidation.nullable(),
        tax_id: taxIdValidation.nullable(),
        date_of_incorporation: dateOfIncorporationValidation.nullable(),
    });
    return allowOptionalFields ? easySchema : schema;
};

export { businessCoreInfoSchema as b };
